/* Light/dark mode switch. A `role="switch"` button with a sun/moon
   visual; the inline-script in index.html has already set the live
   theme before this renders, so the rendered state is always correct. */

import { theme, toggleTheme } from "../theme";

export function ThemeToggle() {
  const isDark = theme.value === "dark";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      class="theme-toggle"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      tabIndex={-1}
    >
      <span class="theme-toggle__icon theme-toggle__icon--sun" aria-hidden="true">
        ☀
      </span>
      <span class="theme-toggle__track" aria-hidden="true">
        <span class="theme-toggle__thumb" />
      </span>
      <span class="theme-toggle__icon theme-toggle__icon--moon" aria-hidden="true">
        ☾
      </span>
    </button>
  );
}
